import { render } from "./InstantRoomManagement.vue?vue&type=template&id=10be82b1&ts=true"
import script from "./InstantRoomManagement.vue?vue&type=script&lang=ts"
export * from "./InstantRoomManagement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__